import {SseNotification} from './sse-notification.model';
import {Balance} from '../finance/balance.model';

export class BalanceSseNotification extends SseNotification {

  public balance: Balance;

  constructor() {
    super();
  }
}
